import { render, staticRenderFns } from "./ScaleService.vue?vue&type=template&id=47db6248&"
import script from "./ScaleService.vue?vue&type=script&lang=js&"
export * from "./ScaleService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports